/* eslint-disable curly */
/* eslint-disable no-param-reassign */
import { isItem } from './utils';
import Vue from 'vue';

export default {

    // Cambios 19 nov

    /**
     * Sets all menu items and section to inactive
     * @param {Object} state Store state
     */
    SET_ALL_INACTIVE(state) {
        state.items.map(x => {
            x.active = false;
            return x;
        });
    },

    /**
     * Sets all submenu items and section to inactive
     * @param {Object} state Store state
     * @param {Number} index Posición del tab a actualizar
     */
    SET_ALL_INACTIVE_CHILD(state, index) {
        setTimeout(() => {
        }, 100);
        if (!state.items[index]) return;

        const children = state.items[index].children;
        if (children) {
            children.forEach(x => {
                x.active = false;
                return x;
            });
            Vue.set(state, 'items', state.items);
        }
    },

    /**
     * Setting section
     * @param {Object} state State
     * @param {Array} section Section
     */
    SET_SECTION(state, section) {
        state.section = section;
        state.section.active = true;
        Vue.set(state, 'section', section);
    },

    /**
     * Sets active current item, deactivating others
     * @param {Object} state State
     * @param {Object} item Item to activate
     */
    SET_ACTIVE(state, item) {
        const items = state.items.map(x => {
            if (isItem(item, x)) {
                x.active = true;
            } else {
                x.active = false;
            }
            return x;
        });
        Vue.set(state, 'items', items);
    },

    /**
     * @override
     */
    SET_ACTIVE_SUBITEM(state, payload) {
        if (!state.items[payload.indexActiveMenu]) return;

        const childs = state.items[payload.indexActiveMenu].children;
        if (childs) {
            const c = childs.indexOf(payload.item);
            childs[c].active = true;
            Vue.set(state, 'items', state.items);
        }
    },

    /**
     * Setting items
     * @param {Object} state State
     * @param {Array} items Array de items de navegación
     */
    SET_ITEMS(state, items) {
        Vue.set(state, 'items', items);
    },

    /**
     * Añade un elemento del menú
     * @param {Object} state State
     * @param {Object} item Nuevo elemento
     */
    INSERT_ITEM(state, item) {
        const items = state.items;
        item.children = [];
        items.push(item);
        Vue.set(state, 'items', items);
    },

    /**
     * @override
     */
    INSERT_SUBITEM(state, payload) {
        const items = state.items;
        if (!items[payload.index]) return;

        if (!items[payload.index].children) {
            items[payload.index].children = [];
        }
        items[payload.index].children.push(payload.subitem);
        Vue.set(state, 'items', items);
    },

    /**
     * Updates item menu
     * @param {Object} state State
     * @param {Object} item item to be updated
     */
    UPDATE_ITEM(state, item) {
        const items = state.items.map(x => {
            return isItem(item, x) ? Object.assign({}, x, item) : x;
        });
        Vue.set(state, 'items', items);
    },

    /**
     * Updates subitem menu
     * @param {Object} state State
     * @param {Object} payload item to be updated
     */
    UPDATE_SUBITEM(state, payload) {
        if (!state.items[payload.index]) return;

        const childs = state.items[payload.index].children;
        const c = childs.findIndex(x => {
            return x.route.name === payload.subitem.route.name &&  x.route.query.id === payload.subitem.route.query.id;
        });
        childs[c].active = true;
    },
    /**
     * Elimina un elemento del menú
     * @param {Object} state State
     * @param {Number} i Index del elemento a eliminar
     */
    REMOVE_ITEM(state, i) {
        const items = state.items.filter((x, index) => {
            return index !== i;
        });
        Vue.set(state, 'items', items);
    },

    /**
     * Cerramos una pestaña del segundo nivel
     * @param {*} state Estado del store
     * @param {*} payload Le pasamos el IndexOf de la pestaña del 1er nivel activa
     * y el IndexOf de la pestaña a cerrar del 2do nivel
     */
    REMOVE_SUBITEM(state, payload) {
        if (!state.items[payload.itemActive]) return;

        const childrens = state.items[payload.itemActive].children.filter((x, index) => {
            return index !== payload.itemActiveChildren;
        });
        state.items[payload.itemActive].children = childrens;
        Vue.set(state, 'items', state.items);
    },

    /**
     * Actualizamos el nombre de una pestaña
     * @param {Object} state Estado del store
     * @param {Object} payload Posición de la pestaña y nombre a actualizar
     */
    UPDATE_ITEM_NAME(state, payload) {
        state.items[payload.index].name = payload.name;
    },

    /**
     * Actualizamos el nombre de una pestaña de 2º nivel
     * @param {Object} state Estado del store
     * @param {Object} payload Información a actualizar
     */
    UPDATE_SUB_ITEM_NAME(state, payload) {
        if (!state.items[payload.index] && !state.items[payload.index].children[payload.indexChildren]) return;

        state.items[payload.index].children[payload.indexChildren].name = payload.name;
    },

    /**
     * Reseteamos todo el store
     * @param {Object} state Estado del store
     */
    RESET(state) {
        state.items = [];
        state.section = {
            name: 'Dashboard',
            active: true,
            icon: 'fal fa-home',
            route: {
                name: 'dashboard'
            }
        };
    }
};
